import { AxiosInstance } from 'axios';

import {
  ToastType,
  IToastAction,
  BookingStatusNames,
  IBookingStatus,
  IBooking,
} from 'shared-types/index';
import NetworkRequestsService from 'external-services/network-requests-service';
import { appURLS } from 'appRoot/app.constants';
import AdminService from 'external-services/diary-admin-service/admin.service';
import ObjectCopyService from 'external-services/object-copy-service';
import StatusConfigService from 'external-services/status-config-service';
import BookingUpdateService from 'external-services/booking-update-service';

const NS = 'SmsService'; // jshint ignore:line
const api: AxiosInstance = NetworkRequestsService.getGlobalAPI();
interface ISmsData {
  bookingId: string;
  userMsisdn: string;
  message: string;
}
class SmsService {
  private ToastActions: any;
  private viewBookingCallback: (booking: IBooking) => void;

  private getBookingStatus: () => {
    statusOptions: IBookingStatus[];
    fullStatusOptions: IBookingStatus[];
  };

  public setup(
    ToastActions: IToastAction,
    getBookingStatus: () => { statusOptions: IBookingStatus[]; fullStatusOptions: IBookingStatus[] },
    viewBookingCallback: (booking: IBooking) => void
  ): void {
    this.ToastActions = ToastActions;
    this.getBookingStatus = getBookingStatus;
    this.viewBookingCallback = viewBookingCallback;
  }
  public send(booking: any, phone: string, message: string) {
    const smsData: ISmsData = {
      bookingId: booking._id,
      userMsisdn: phone.split(' ').join(''),
    } as ISmsData;

    if (message) {
      smsData.message = message;
    }

    api
      .post(
        appURLS.API + '/restaurants/venues/' + AdminService.getVenue().id + '/sms',
        smsData
      )
      .then(() => {
        if (booking.status.name === BookingStatusNames.SmsFailed) {
          const orgBooking = ObjectCopyService.angularSafeCopy(booking);
          const fullStatusOptions = this.getBookingStatus().fullStatusOptions;
          const sentStatus = StatusConfigService.getStatusByName(
            BookingStatusNames.SentSms,
            fullStatusOptions
          );
          if (sentStatus) {
            booking.status = sentStatus;
            BookingUpdateService.updateFromAnywhere(booking, orgBooking);
          }
        }
      })
      .catch((err) => {
        const orgBooking = ObjectCopyService.angularSafeCopy(booking);
        const fullStatusOptions = this.getBookingStatus().fullStatusOptions;
        const failedStatus = StatusConfigService.getStatusByName(
          BookingStatusNames.SmsFailed,
          fullStatusOptions
        );
        if (failedStatus) {
          booking.status = failedStatus;
          BookingUpdateService.updateFromAnywhere(booking, orgBooking);
        }
        this.ToastActions.showToastFullOptions({
          msg: `Failed to send SMS to ${booking.name || booking.firstName}`,
          type: ToastType.error,
          isImportant: false,
          hideDismissBtn: true,
          customButton1Text: 'View Booking',
          handleCustomButton1: () => {
            this.ToastActions.clearToast();
            this.viewBookingCallback(booking);
            // this.$rootScope.$broadcast('edit-booking', null, booking);
          },
          customButton2Text: 'Retry',
          handleCustomButton2: () => {
            this.ToastActions.clearToast();
            setTimeout(() => {
              this.send(booking, phone, message);
            }, 1000);
          },
          customButton3Text: 'Close',
          handleCustomButton3: () => {
            this.ToastActions.clearToast();
          },
        });
      });
  }
}

const instance = new SmsService();
export default instance as SmsService;
